import React from 'react';
import { Admin, Resource, Layout } from 'react-admin';
import dataProvider from './dataProvider';
import authProvider from './authProvider';
import Dashboard from './dashboard';
import AppMenu from './AppMenu';
import { ApartmentList, ApartmentEdit, ApartmentCreate, ApartmentShow } from './apartments';
import { GuestList, GuestEdit, GuestCreate, GuestShow } from './guests';
import { BookingList, BookingEdit, BookingCreate, BookingShow } from './bookings';
import { TemplateList, TemplateEdit, TemplateCreate } from './templates';
import { TriggerList, TriggerEdit, TriggerCreate } from './triggers';
import Integrations from './integrations';
import { BlogPostList, BlogPostCreate, BlogPostEdit, BlogPostShow } from './blog';
import { CommentList, CommentCreate, CommentEdit, CommentShow } from './comments';
import {
  ApartmentPriceListRedirect,
  ApartmentPriceEdit,
  ApartmentPriceCreate,
  ApartmentPriceShow,
} from './prices';
import {
  BookingSourceList,
  BookingSourceEdit,
  BookingSourceCreate,
  BookingSourceShow,
} from './bookingSources';

const AppLayout = (props) => <Layout {...props} menu={AppMenu} />;

const App = () => (
  <Admin dataProvider={dataProvider} authProvider={authProvider} dashboard={Dashboard} layout={AppLayout}>
    <Resource
      name="apartments"
      list={ApartmentList}
      show={ApartmentShow}
      edit={ApartmentEdit}
      create={ApartmentCreate}
    />
    <Resource
      name="apartment-prices"
      list={ApartmentPriceListRedirect}
      show={ApartmentPriceShow}
      edit={ApartmentPriceEdit}
      create={ApartmentPriceCreate}
    />
    <Resource
      name="guests"
      list={GuestList}
      show={GuestShow}
      edit={GuestEdit}
      create={GuestCreate}
    />
    <Resource
      name="bookings"
      list={BookingList}
      show={BookingShow}
      edit={BookingEdit}
      create={BookingCreate}
    />
    <Resource
      name="templates"
      list={TemplateList}
      edit={TemplateEdit}
      create={TemplateCreate}
    />
    <Resource
      name="triggers"
      list={TriggerList}
      edit={TriggerEdit}
      create={TriggerCreate}
    />
    <Resource
      name="integrations"
      list={Integrations}
    />
    <Resource
      name="blogposts"
      list={BlogPostList}
      show={BlogPostShow}
      edit={BlogPostEdit}
      create={BlogPostCreate}
    />
    <Resource
      name="comments"
      list={CommentList}
      show={CommentShow}
      edit={CommentEdit}
      create={CommentCreate}
    />
    <Resource
      name="booking-sources"
      list={BookingSourceList}
      show={BookingSourceShow}
      edit={BookingSourceEdit}
      create={BookingSourceCreate}
    />
  </Admin>
);

export default App; 
